import React from "react"
import css from "../css"

if (css) require('./modal.scss')

export const modalDepth = (delta=0) => Math.max(0, parseInt(document.body.getAttribute('modals') || '0') + delta)

export const Modal = React.createClass({
    getInitialState() {
        return {
            show: false
        } 
    },
    componentDidMount() {
        if (this.props.attach)
            this.props.attach[this.props.name] = this
        document.body.setAttribute('modals', modalDepth())
    },
    componentWillUnmount() {
        if (this.props.attach)
            this.props.attach[this.props.name] = undefined
    },  

    open() {
        this.setState({show: true}) 
        if (this.props.onopen)
            setTimeout(this.props.onopen, 0)
        document.body.setAttribute('modals', modalDepth(1))
    },

    close() {
        this.setState({show:false})
        document.body.setAttribute('modals', modalDepth(-1))
    },

    render() {
        return (
            <span>
                {this.props.button
                    ? <button onClick={this.open}>{this.props.button}</button>
                    : null
                }
                <div className="modal-background"
                     onClick={e=>{this.refs.content.contains(e.target) || this.close()}}
                     style={{
                        display: this.state.show ? 'block' : 'none'
                     }}
                     >
                    <div className="close" onClick={this.close}></div>
                    <div className="modal-content" ref="content">
                        {this.props.children}
                    </div>
                </div>
            </span>
        )
    }
})



// WEBPACK FOOTER //
// ./src/components/modal.jsx